<app-loading *ngIf="!(user$ | async)"></app-loading>
<app-data-loading *ngIf="user$ | async"></app-data-loading>
<router-outlet></router-outlet>
